<template>
    <v-dialog v-model="dialog" :width="width">
        <v-card flat>
            <v-card-title class="pl-3">Mails</v-card-title>
            <v-divider class="mb-0"></v-divider>
            <mail_table :mails="mails"/>
            <v-card-actions class="mt-2">
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="closeDialog">Close</v-btn>
            </v-card-actions>
        </v-card>        
    </v-dialog>
</template>
  
<script>

    import mail_table from '@/components/ui/tables/mails.vue';

    export default {    
        props:{
            width:{
                type: String,
                default: '900px'
            }
        },
        components: {
            mail_table
        },
        data() {
            return {
                dialog: false,
                mails: [],
            }
        },
        methods: {
            closeDialog(){
                this.dialog = false;
            },
            open(hokl_encrid) {
                this.dialog = true;
                this.$axios
                    .post("ares/json/ares/huov/hokl/getHoklEmails.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getHoklEmails",
                        },
                        getHoklEmails: {
                            hokl_encrid: hokl_encrid,
                        },
                    })
                    .then((res) => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {
                            this.mails = res.data.getHoklEmails.mail;
                        }
                    })
            },
        },
    };
</script>
  
  